// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3oYkt","withTopPadding":"_1vmdi","bottomChildren":"_10hNB","footerbuttons":"_2UjsI"};